import Title from "@/components/title";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import _ from "lodash";
import moment from "moment";
import React from "react";
// Components
import ProfitAndLossDetailTable from "@/components/DataTable/profitAndLossDetailTable";
import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import Layout from "@/components/layout";
import { getProducts, getProfitAndLoss } from "@/fetch/fetchStatistics";
import LoadingButton from "@mui/lab/LoadingButton";

const ProfitAndLossPage = (props) => {
  const { open, setOpen } = props;

  const [productOptions, setProductOptions] = React.useState([]);
  const [slideTranOn, setSlideTranOn] = React.useState(false);

  const fetchProduct = async () => {
    const { data: products } = await getProducts();
    setProductOptions(products);
    setSlideTranOn(true);
  };

  React.useEffect(() => {
    fetchProduct();
  }, []);

  const PnLSession = React.memo((prop) => {
    const { index } = prop;
    const filterAnchorRef = React.useRef(null);
    const dataPickerStartRef = React.useRef(null);
    const dataPickerEndRef = React.useRef(null);

    const [openDateFilter, setOpenDateFilter] = React.useState(false);
    const [selectedDate, setSelectedDate] = React.useState({
      startDate: null,
      endDate: null,
    });
    const [data, setData] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);
    const [selectedProduct, setSelectedProduct] = React.useState([]);
    const fetch = async () => {
      try {
        setIsLoading(true);
        const { data: result } = await getProfitAndLoss(
          [selectedProduct],
          moment(selectedDate.startDate).format("YYYY-MM-DD"),
          moment(selectedDate.endDate).format("YYYY-MM-DD"),
          false,
          "all"
        );
        setData(result);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };
    const handleCloseDateFilter = (event) => {
      if (
        filterAnchorRef.current &&
        filterAnchorRef.current.contains(event.target)
      ) {
        return;
      }
      setOpenDateFilter(false);
    };
    return (
      <Grid size={6}>
        <Box>
          <Grid container spacing={2}>
            <Grid size={6}>
              <ProductAutoComplete
                id={`product-auto-${index}`}
                selectByCategory
                fullWidth={true}
                productOptions={productOptions}
                handleOnChange={(value) => {
                  setSelectedProduct(value);
                }}
                selectedValue={selectedProduct}
                error={!selectedProduct}
                selectAll={false}
                multiple={true}
              ></ProductAutoComplete>
            </Grid>
            <Grid sx={{ mt: 1 }} size={6}>
              <Button
                ref={filterAnchorRef}
                variant="contained"
                onClick={() => {
                  // setDateFilterMode(1);
                  setOpenDateFilter(true);
                  //dataPickerStartRef1.current?.parentElement.click();
                }}
              >
                {selectedDate.startDate && selectedDate.endDate
                  ? `${moment(selectedDate.startDate).format(
                      "YYYY-MM-DD"
                    )} - ${moment(selectedDate.endDate).format("YYYY-MM-DD")}`
                  : "選擇日期"}
              </Button>
              <Popper
                sx={{
                  zIndex: 1,
                  width: 250,
                  mt: "20px!important",
                }}
                open={openDateFilter}
                anchorEl={filterAnchorRef.current}
                role={undefined}
                placement={"bottom"}
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === "bottom" ? "center top" : "center right",
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleCloseDateFilter}>
                        <div>
                          <DatePicker
                            views={["year", "month", "day"]}
                            disableFuture
                            components={{
                              OpenPickerIcon: () => (
                                <CalendarMonthIcon ref={dataPickerStartRef} />
                              ),
                            }}
                            label="Start Date"
                            onClose={() => {
                              dataPickerEndRef.current.parentElement.click();
                            }}
                            value={selectedDate.startDate}
                            onChange={(newValue) => {
                              setSelectedDate((prev) => {
                                return {
                                  ...prev,
                                  startDate:
                                    moment(newValue).format("YYYY-MM-DD"),
                                  endDate:
                                    prev.endDate ??
                                    moment(newValue)
                                      .endOf("month")
                                      .format("YYYY-MM-DD"),
                                };
                              });
                            }}
                            renderInput={(params) => (
                              <TextField {...params} sx={{ width: "100%" }} />
                            )}
                          />
                          <DatePicker
                            views={["year", "month", "day"]}
                            disableFuture
                            value={selectedDate.endDate}
                            minDate={moment(selectedDate.startDate)}
                            label="End Date"
                            components={{
                              OpenPickerIcon: () => (
                                <CalendarMonthIcon ref={dataPickerEndRef} />
                              ),
                            }}
                            onChange={(newValue) => {
                              setSelectedDate((prev) => {
                                return {
                                  ...prev,
                                  endDate:
                                    moment(newValue).format("YYYY-MM-DD"),
                                };
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                sx={{ width: "100%", mt: "10px!important" }}
                              />
                            )}
                          />
                        </div>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
              <LoadingButton
                sx={{ ml: 2 }}
                disabled={
                  !moment(selectedDate.startDate).isValid() ||
                  !moment(selectedDate.endDate).isValid() ||
                  selectedProduct.length <= 0
                }
                loading={isLoading}
                variant="contained"
                color="success"
                onClick={() => {
                  fetch();
                }}
              >
                確認
              </LoadingButton>
            </Grid>
          </Grid>
        </Box>
        {!_.isEmpty(data) && (
          <ProfitAndLossDetailTable selectedDate={selectedDate} data={data} />
        )}
      </Grid>
    );
  });

  return (
    <Layout header="Main Page" selectedIndex={1} open={open} setOpen={setOpen}>
      <Title title="Profit & Loss" />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <Grid container sx={{ mb: 2 }}>
          <PnLSession index={0}></PnLSession>
          <PnLSession index={1}></PnLSession>
        </Grid>
      </Fade>
    </Layout>
  );
};

export default ProfitAndLossPage;
